import { RouteConfig } from 'vue-router';

import { partnersRoute } from './partners/list.route';
import { partnerDetailsRoute } from './partners/details.route';

export const partnerContainerRoute: RouteConfig = {
  path: 'partners',
  component: () =>
    import(/* webpackChunkName: "Router" */ '@/components/Router.vue'),
  children: [partnersRoute, partnerDetailsRoute]
};
